import React, { useEffect } from 'react';
import { initFacebookPixel } from '../facebookPixel';
import './Signup.css';

const Signup = () => {
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  const handleBookTrial = () => {
    window.location.href = '/trial-form';
  };
  return (
    <div className="stick">
      <button onClick={handleBookTrial} className="sticky-button">
        Book Trial for Badminton
      </button>
    </div>
  );
};

export default Signup;
